<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="tableData"
    :toolbar-config="tableToolbar"
    :columns="tableColumns"
    :loading="loading"
    size="small"
    resizable
    border
    :header-cell-style="headerCellStyle"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:specInfo="{ row }">
      <span>{{ row.spec }} {{ row.specUnit }}</span>
    </template>
    <template v-slot:opt="{ row }">
      <div>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              $emit('openDetailDialog', {
                type: 'detail',
                code: row.changeOrderGoodsSpecCode
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="!disabled"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="
              $emit('openDetailDialog', {
                type: 'edit',
                code: row.changeOrderGoodsSpecCode
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-if="!disabled"
        >
          <i
            class="el-icon-delete tool-btn"
            @click="del(row.changeOrderGoodsSpecCode)"
          ></i>
        </el-tooltip>
      </div>
    </template>
    <!-- <template v-slot:empty="{}">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
        </p>
      </div>
    </template> -->
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        }
      },
      tableColumns: tableColumns(this)
    }
  },
  methods: {
    headerCellStyle({ column }) {
      if (column.property !== 'xxx') {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff'
        }
      }
    },
    del(changeOrderGoodsSpecCode) {
      this.$emit('batchDel', [changeOrderGoodsSpecCode])
    },
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning'
        })
        return
      }
      if (data.length > 20) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_max_select_rows') ||
            '最多可选择20行！',
          type: 'warning'
        })
        return
      }
      if (type === 'code') {
        return data.map((row) => {
          return row.changeOrderGoodsSpecCode
        })
      }
      return data
    }
  }
}
</script>
